const Wrapper = props => props.children;

export default Wrapper;



// WEBPACK FOOTER //
// ./src/customModules/Common/components/Wrapper.js